
import React, { useState, useEffect } from 'react';
import Image from 'next/image';
import styles from '../styles/LatestPost.module.css';
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import SectionHeader from "../widgets/SectionHeader";
import Link from 'next/link';
// import _ from "lodash";
import * as LIB from '../lib/common';
import { filterProtectedContent, useLoginStatus } from '../lib/protectedContent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/fontawesome-free-regular';

const LatestPost = ({ data, pageTitle, topPath, topicID }) => {
    const clockIcon = <FontAwesomeIcon icon={faClock} />;
    const [isLoggedIn] = useLoginStatus();
    const visibleData = filterProtectedContent(data, isLoggedIn);

    const renderLink = (post) => {
        //render the post's link
        //different format to open the url
        if (topicID && topicID == 'vid') {
            //video topic
            return ('https://www.youtube.com/watch?v=' + post.code);
        } else if (post.id) {
            //normal post
            return (LIB.getBasepath(`/posts/${post.id}/` + encodeURIComponent(post.title.replace(/ /g, ''))));
        } else if (post.code) {
            //video post
            return ('https://www.youtube.com/watch?v=' + post.code);
        } else {
            //no link available
            return ('javascript:void(0)');
        }
    }

    const renderAtagTarget = (post) => {
        //how the link to be opened
        if (topicID && topicID == 'vid') {
            return ('_blank');
        } else if (post.id) {
            return ('_self');
        } else if (post.code) {
            return ('_blank');
        } else {
            return ('_self');
        }
    }

    const renderImg = (imgPath) => {
        if (imgPath == "https://ziondaily.com/2.0/img_s/default_news_thumbnail.jpg" || imgPath == '') {
            let typeID = '03a'
            imgPath = LIB.getBasepath(`/images/topic/${typeID}.jpg`);
        }

        //render post image
        return (
            <div className={styles.imgHolder}>
                <Image
                    className={styles.img}
                    src={imgPath}
                    alt="圖片"
                    sizes="100vw"
                    height={220}
                    width={400}
                    style={{
                        width: '100%',
                        height: 'auto',
                    }}
                />
            </div>
        );
    }

    const renderContent = (post) => {
        //render post content
        return (
            <Container fluid>
                <Row>
                    <Col className={styles.titleColum}>
                        <div className={styles.bottomArea}>
                            <div className={styles.title}>{post.title}</div>
                            <div className={styles.excerpt}>{post.excerpt}</div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} className='d-block d-sm-none'>
                        <div className={styles.divider}></div>
                    </Col>
                </Row>
                <Row className={styles.infoRow}>
                    <Col className={styles.fullColum}>
                        <div className={styles.date}>{post.post_date.substring(0, 10)}</div>
                    </Col>
                    <Col className={styles.fullColum}>
                        <div className={styles.category}>{post.topic_title ? post.topic_title : '精選推介'}</div>
                    </Col>
                </Row>
            </Container>
        );
    }

    //render latest post section
    return (
        <div className="viewport">
            <SectionHeader title={pageTitle} path={topPath} headerID={topicID} />
            <Container fluid>
                <Row>
                    {visibleData && visibleData.slice(0, 8).map((post, index) => (
                        //render each post card
                        <Col key={index} md={6} lg={3} className={styles.colum}>
                            <a href={renderLink(post)} target={renderAtagTarget(post)}>
                                <div className={styles.card}>
                                    {/* card image */}
                                    {renderImg(post.thumbnail)}

                                    {/* card content */}
                                    {renderContent(post)}
                                </div>
                            </a>
                        </Col>
                    ))}
                </Row>
            </Container>
        </div>
    );
}




export default LatestPost;